import { ThunkAction } from 'redux-thunk'

import { updateLoginAction } from './login'

import { OrgAccountFormData } from 'admin/components/pages/OrgAccounts/OrgAccountForm'
import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { OrgAccountType } from 'admin/types'
import
 createApiReducer,
  { requestDataFor, receiveDataFor, resetDataFor, handleErrorFor } from 'redux/utils/createApiDuck'
import { APIState } from 'types'

const moduleName = `${config.appName  }/orgAccount`

export default createApiReducer(moduleName)

export function fetchOrgAccount(orgAccountId: string): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.getOrgAccount(orgAccountId)
      .then(data => {
        dispatch(receiveDataFor(moduleName)(data))
        return data
      })
      .catch(error => dispatch(handleErrorFor(moduleName)(error)))
  }
}


export function fetchOrganization(
  orgKimId: number
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .getOrganization(orgKimId)
      .then((organization) => {
        dispatch(receiveDataFor(moduleName)(organization))
        return organization
      })
      .catch((error) => dispatch(handleErrorFor(moduleName)(error)))
  }
}


export function createOrgAccount(data: OrgAccountFormData): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.createOrgAccount(data)
      .then(orgAccountId => {
        dispatch(fetchOrgAccount(orgAccountId as string))
        return orgAccountId
      })
      .catch(error => dispatch(handleErrorFor(moduleName)(null)))
  }
}

export function updateOrgAccount(orgAccountId: string, data: OrgAccountFormData): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.updateOrgAccount(orgAccountId, data)
      .then(() => {
        dispatch(fetchOrgAccount(orgAccountId))
        // update login if updated account is logged in account
        if (orgAccountId === getState().login.data.orgAccountId) {
          dispatch(updateLoginAction({ ...getState().login.data, ...data}))
        }
        
      })
      .catch(error => dispatch(handleErrorFor(moduleName)(error)))
  }
}

export function inactivateOrgAccount(orgAccountId: string): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api.inactivateOrgAccount(orgAccountId)
      .then(() => {
        dispatch(resetDataFor(moduleName)(null))
      })
      .catch(error => handleErrorFor(moduleName)(error))
  }
}

export interface OrgAccountState extends APIState {
  data: OrgAccountType
}
